import React, { FunctionComponent } from 'react'
import GatsbyImage from 'gatsby-image'
import { has } from 'lodash'
import { ContentfulRichTextGatsbyReference } from 'gatsby-source-contentful/rich-text'

import FunnelCta from 'components/funnel-cta'

import { RTFBlockComponentProps, RTFBlockComponentExport } from '../../types'

import {
  signupCta,
  signupCtaImage,
  signupCtaContent,
  signupCtaAddress,
  signupCtaButton,
} from './index.module.scss'

export interface RTFContentfulSignupCtaGraphQLResult
  extends ContentfulRichTextGatsbyReference {
  __typename: EF.RTFBlockTypename.ContentfulSignupCta
  address: string
  buttonText: string
  image: EF.FixedImageNode
}

export interface ContentfulSignupCtaBlockProps extends RTFBlockComponentProps {
  address: string
  buttonText: string
  image: EF.FixedImageNode
}

const ContentfulSignupCtaBlock: FunctionComponent<ContentfulSignupCtaBlockProps> = ({
  address,
  buttonText,
  image,
}) => {
  return (
    <div className={signupCta}>
      <div className={signupCtaImage}>
        <GatsbyImage fixed={image.fields.asset.fixed} alt={image.title} />
      </div>
      <div className={signupCtaContent}>
        <strong className={signupCtaAddress}>{address}</strong>
        <FunnelCta className={signupCtaButton} text={buttonText} />
      </div>
    </div>
  )
}

const componentExport: RTFBlockComponentExport = {
  component: ContentfulSignupCtaBlock,
  isValid: ({ address, buttonText, image }) =>
    !!address && !!buttonText && !!image && has(image, 'fields.asset.fixed'),
}

export default componentExport
